<div class="d-flex align-items-center py-2 px-3 cursor-pointer"
     (click)="selected = !selected; valueSelected.emit(selected)">
  <input class="form-check-input m-0 me-1" type="checkbox" [(ngModel)]="selected" style="cursor: pointer">
  <label class="d-flex flex-grow-1" style="cursor: pointer">
    <span class="text-truncate py-1">
      <app-highlight [term]="term" [result]="facetValue.formattedValue || facetValue.value"></app-highlight>
    </span>
    @if (facetValue.count) {
      <span class="text-secondary ms-1 py-1">({{ facetValue.count }})</span>
    }
  </label>
</div>
